<template>
    <div class="book_info_item">
        <a :href=" 'http://writebookapi.dangdang.com/h5-share?bookid=' + content.bookId "  dd_name="进入书单详情页">
            <h2>{{content.bookTitle}}</h2>
            <img class="p_img" v-lazy="content.bookAttachUrl" alt="">
            <p class="p_text">{{content.bookContent}}</p>
        </a>
        <div class="operate_div">
            <span class="p_type">{{content.bookTypeName}}</span>
            <div class="p_operta">
                <div class="p_op_div" @click="collect_product" :class="{isLiked}" dd_name="关注"><span class="p_op_icon collect_icon"></span>{{content.likeNum && content.likeNum > 0? content.likeNum : '关注' }}</div>
                <a :href=" 'http://writebookapi.dangdang.com/h5-share?bookid=' + content.bookId "  dd_name="进入书单详情页" class="p_op_div"><span class="p_op_icon reply_icon"></span>{{content.commentNum && content.commentNum > 0? content.commentNum : '回复'}}</a>
            </div>
        </div>
        
        <div class="p_updata_div">
            <div class="p_time">{{content.creationDate}}</div>
            <a class="p_updata" v-if="is_self" dd_name="更新" href="http://writebookapi.dangdang.com/h5-upstatic">更新</a>
        </div>
        
    </div>
</template>
<script>
export default {
    name: 'bookinfoItem',
    props: ['content', 'is_self'],
    data() {
        return {
            isLiked : this.content.isLiked && this.content.isLiked == '1' ? true : false
        }
    },
    methods: {
        collect_product: function(){
            // 关注
            if(this.is_self){
                // 我的主页，点击关注进入书单详情页
                window.location.href = 'http://writebookapi.dangdang.com/h5-share?bookid=' + this.content.bookId
                return false;
            }

            this.$http({
                method: 'post',
                url: 'my.php',
                data: {
                  action: 'follow_book',
                  book_id: this.content.bookId,
                  is_follow: this.isLiked? '0' : '1' //关注，1-关注，0-取消关注
                }
            }).then((result) => {
                // console.log('关注：' + JSON.stringify(result) );
                var data = result.data;
                if(data.errorCode == 0 ){
                    this.isLiked? this.content.likeNum -- : this.content.likeNum ++;
                    this.isLiked = !this.isLiked;
                }

            }).catch((e) => {
                this.errobj = {
                    type: 'pop',
                    errorMsg: '网络错误请稍后重试'
                }
            })

            
        }
    }

}
</script>
<style lang="stylus">
    @import '../common/stylus/omit.styl'
    .book_info_item
        &:last-child
            border-bottom: 0
        border-bottom: 1px solid #dddddd
        padding-bottom: .5rem
        h2
            color:#323232
            line-height: 2.9rem
            height: 2.9rem
            font-size: .9rem
            omit-line(num=1)
        .p_img
            display: block
            width: 100%
        .p_text
            padding-top: .6rem
            padding-bottom: .1rem
            max-height: 2.7rem
            line-height:.9rem
            font-size: .65rem
            color: #9b9b9b
            omit-line(3)
        .operate_div
            display: block
            overflow: hidden
            height: .55rem
            padding: .5rem 0
            font-size: .6rem
        .p_type
            display: block
            float: left
            color:#c8c8c8
        .p_operta
            display: block
            overflow:hidden
            float:right
            color: #c8c8c8
            .isLiked
                color: #fc4843
                .collect_icon
                    background-image:url('../assets/images/collect_click.png')!important
            .p_op_div
                display: block
                position: relative
                float: left 
                padding-left: .9rem
                margin-left: 0.5rem
                .p_op_icon              
                    display: block
                    position: absolute
                    top: 0
                    left: 0
                    height: 100%
                    width: 0.7rem
                    line-height: 0.6rem
                    background-position: center
                    background-size: 0.7rem 0.6rem
                    background-repeat: no-repeat
                .collect_icon
                    background-image:url('../assets/images/collect.png')
                .reply_icon
                    background-image:url('../assets/images/comment.png') 
        .p_updata_div 
            display: block
            overflow: hidden
            padding: .5rem 0rem     
            .p_time
                display: block
                float:left
                line-height: 1rem
                font-size: .6rem
                color: #c8c8c8
            .p_updata
                display: block
                float:right
                width:2.2rem
                height: .95rem
                line-height: .95rem
                text-align: center
                font-size:.6rem
                color: #fc4843
                border:1px solid #fc4843
                border-radius: .2rem


</style>



// WEBPACK FOOTER //
// bookInfoItem.vue?5bbc6c42